export default __webpack_public_path__ + "static/media/bonus-round.5aa51442.png";